// Everyone an admin needs to act on, in one queue: public sign-ups not yet
// approved (hidden from the allocation picker until they are) and workers whose
// submitted profile is waiting for review. Mirrors mobile/src/utils/workerReview.js;
// approveWorkerReview on the server clears whichever applies.
export const needsReview = worker => !!worker && !worker.archived
    && (worker.publicSignupApproved === false || worker.status === 'Pending Review')
